import React from 'react'
import { useParams } from 'react-router-dom'
import { CryptoState } from '../CryptoContext';
import { useState,useEffect } from 'react';
import { SingleCoin } from '../config/api';
import axios from 'axios';
import { makeStyles } from '@material-ui/styles';
import Coininfo from '../component/Coininfo';
import { Typography,LinearProgress } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';

const useStyles=makeStyles({
  container:{
     display:'flex',
  },
  sidebar:{
    display:"flex",
    width:'30%',
    flexDirection:"column",
    alignItems:'center',
    marginTop:'20px',
    borderRight:'2px solid gray'
  },
  description:{
    padding:'20px',
    width:"100%",
    textAlign:'jusify',
  },
  heading:{
    fontSize:'20px',
    fontWeight:'700'
  }

 })

const Coins = () => {
 
const {id}= useParams();
console.log(id)
const [coin, setcoin] = useState();
const {currency,symbol}=CryptoState();

const getcoins= async()=>{
  const {data}=await axios(SingleCoin(id))
  setcoin(data)
}
 // eslint-disable-next-line 
useEffect(() => {
    getcoins()
}, [currency])


// console.log(coin);

 const classes=useStyles()
  return (
    <>
     {coin?'':<LinearProgress style={{backgroundColor:'gold'}} ></LinearProgress>}
      <div className={classes.container} >
        <div className={classes.sidebar} > 
         <img src={coin?.image.large} alt='name' height="200px" />
          <Typography variant='h3' style={{fontWeight:'700'}} >  {coin?.name} </Typography>
          <Typography variant='subtitle1' className={classes.description} > {ReactHtmlParser(coin?.description.en) } </Typography>

          <div className={classes.marketdata}>
            <span>
              <Typography variant='h5' className={classes.heading} > Rank: {coin?.market_cap_rank} </Typography>
            </span>
          </div>

          <div className={classes.marketdata}>
            <span>
              <Typography variant='h5' className={classes.heading} > Current Price: {symbol} {coin?.market_data.current_price[currency.toLowerCase()]}    </Typography>
            </span>
          </div>
         
          <div className={classes.marketdata}>
            <span>
              <Typography variant='h5' className={classes.heading} > Market Cap:{symbol} {coin?.market_data.market_cap[currency.toLowerCase()]}M  </Typography>
            </span>
          </div>


       </div>

       <Coininfo coin={coin} />
      </div>

      {/* Chart */}

     

      </>
  )
}

export default Coins